import { HttpService } from 'core/modules/network-service';
import { get, merge } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';
import { REDUCER } from 'constants/entity-names';
import { getStore } from 'store';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc ShipppingAndPayment defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { ShipppingAndPaymentService } from 'services/shipppingAndPayment';
 *
 * // create service instance and send/cancel request
 * const shipppingAndPaymentService = new ShipppingAndPaymentService();
 * const result = await shipppingAndPaymentService.fetchData( '<user-id>' ); // fetch data
 * shipppingAndPaymentService.cancel(); // cancel an active request
 */
export class ShipppingAndPaymentService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url, data } ) {

        const callerType = get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data,
                    {
                        context: {
                            callerType
                        }
                    }
                )
            } );

            // extract widgets from the response
            const visibility = get( response, 'body.component.visibility', {} );
            const widgets = get( response, 'body.component.structure.widgets', [] );
            const navActions = get( response, 'body.component.structure.navActions', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    widgets: getVisibleItems( widgets, visibility ),
                    navActions: getVisibleItems( navActions, visibility ),
                },
            };
            
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    async submitShippingAndPaymentInfo( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
     
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    async moveToPreviousStep( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
     
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    async cancelOrder( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
     
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
